/**
 * R2IT Golf Scoring API
 * This swagger document describes the available API endpoints.
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ModulesLeaderboardsApplicationGetPlayerStatsCourseSummaryPlayerStatsCourseRoundResponse { 
    roundNumber?: number;
    fwysHit?: number;
    fwysAtt?: number;
    fwysPct?: number;
    fwysRank?: string;
    grnsHit?: number;
    grnsAtt?: number;
    grnsPct?: number;
    grnsRank?: string;
    ssMade?: number;
    ssAtt?: number;
    ssPct?: number;
    ssRank?: string;
    putts?: number;
    puttsAvg?: number;
    puttsRank?: string;
    drvs?: number;
    drvDistAvg?: number;
    drvDistRank?: string;
}